import React, { Component } from 'react';
import {Route} from 'react-router-dom';

import Home from './Component/Home';
import About from './Component/About';
import Navigation from './Component/Navigation';
import Terms from './Component/Terms';
import Policy from './Component/Policy';

import './materialize.min.css';

class App extends Component {
  render() {
    return (
      <div>
        <Navigation/>
        <Route exact={true} path={'/'} component={Home} />
        <Route exact={true} path={'/terms'} component={Terms} />
        <Route exact={true} path={'/policy'} component={Policy} />
        <Route exact={true} path={'/about'} component={About} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js